/* eslint-disable
    eqeqeq,
    @typescript-eslint/no-use-before-define,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import React from 'react';
import Promise from 'bluebird';

import { Analytics } from '@trello/atlassian-analytics';
import { isDesktop } from '@trello/browser';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';

// eslint-disable-next-line no-restricted-imports
import { Controller } from 'app/scripts/controller';
import { navigate } from 'app/scripts/controller/navigate';
import {
  getOrganizationAccountUrl,
  getOrganizationBillingUrl,
} from 'app/scripts/controller/urls';
import { Auth } from 'app/scripts/db/Auth';
import { ModelLoader } from 'app/scripts/db/model-loader';
import { Board } from 'app/scripts/models/board';
import { templates } from 'app/scripts/views/internal/templates';
import { View } from 'app/scripts/views/internal/view';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { maybeDisplayOrgMemberLimitsError } from 'app/scripts/views/organization/MemberLimitsError';
import { OrgCreateEnterpriseTemplate } from 'app/scripts/views/templates/OrgCreateEnterpriseTemplate';
import { OrgCreateTemplate } from 'app/scripts/views/templates/OrgCreateTemplate';
import { renderComponent } from 'app/src/components/ComponentWrapper';
import { TeamTypeSelect } from 'app/src/components/TeamTypeSelect';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';

const formatEmailDomain = function (emailDomain) {
  if (emailDomain) {
    return `(${emailDomain})`;
  } else {
    return '';
  }
};

class CreateOrgView extends View {
  static initClass() {
    this.prototype.viewTitleKey = 'create organization';

    this.prototype.events = {
      'click .js-save': 'submit',
      'submit form': 'submit',
      'input .js-display-name'() {
        return this.updateSubmitButton();
      },
    };
  }

  constructor(options) {
    super(options);
    this.onChangeTeamType = this.onChangeTeamType.bind(this);
    this.renderTeamTypeSelect = this.renderTeamTypeSelect.bind(this);
  }

  initialize({ createOpts, trackingOpts }) {
    this.createOpts = createOpts;
    this.trackingOpts = trackingOpts;
    if (this.trackingOpts == null) {
      this.trackingOpts = { category: null, method: null, context: {} };
    }
    if (this.createOpts == null) {
      this.createOpts = {
        isBusinessClass: false,
        boardToAddToOrg: false,
        isEnterprise: false,
      };
    }
    const [, domain] = Array.from((Auth.me().get('email') || '').split('@'));
    this.emailDomain = domain ? domain : '';
    this.teamTypeValue = '';
    return this;
  }

  getValue(name) {
    return $(`[name=${name}]`, this.$el).val()?.trim();
  }

  render() {
    let template, templateArgs;

    if (this.createOpts.isEnterprise) {
      template = OrgCreateEnterpriseTemplate;
      templateArgs = {
        enterprises: Auth.me().enterpriseList,
        dontUpsell: isDesktop(),
      };
    } else {
      template = OrgCreateTemplate;
      templateArgs = {
        dontUpsell: isDesktop(),
        emailDomain: formatEmailDomain(this.emailDomain),
        boardToAddToOrg: this.createOpts.boardToAddToOrg,
        memberCount:
          this.model.memberList != null
            ? this.model.memberList.length
            : undefined,
        isPrivateTemplate: this.createOpts.isPrivateTemplate,
      };
    }

    this.$el.html(templates.fill(template, templateArgs));
    this.updateSubmitButton();
    this.renderTeamTypeSelect();

    return this;
  }

  updateSubmitButton() {
    const isDisabled =
      this.getValue('displayName').length === 0 || this.teamTypeValue === '';
    return $('.js-save', this.$el).prop('disabled', isDisabled);
  }

  submit(e) {
    stopPropagationAndPreventDefault(e);

    if (maybeDisplayOrgMemberLimitsError($(e.target), null, Auth.me())) {
      return;
    }

    const data = {};

    $('.js-save', this.$el).prop('disabled', true).addClass('disabled');

    for (const name of ['displayName', 'desc', 'enterprise']) {
      data[name] = this.getValue(name);
    }

    if (this.teamTypeValue !== '') {
      data['teamType'] = this.teamTypeValue;
    }

    Auth.me().organizationList.create(data, {
      modelCache: this.modelCache,
      silent: true,
      success: (data) => {
        if (this.createOpts.boardToAddToOrg) {
          this.createOpts.boardToAddToOrg.update({ idOrganization: data.id });

          if (this.createOpts.isPrivateTemplate) {
            this.model.setPref('isTemplate', false).save();
          }
        }

        return ModelLoader.loadOrganizationMembersMinimal(data.id)
          .then(() => {
            if ($('.js-add-members', this.$el).prop('checked')) {
              const org = this.model.getOrganization();
              return Promise.map(
                this.model.memberList.models,
                function (member) {
                  if (!org.isMember(member)) {
                    return org.changeMemberRole(member, { type: 'normal' });
                  }
                },
                { concurrency: 3 },
              );
            }
          })
          .then(() => {
            if (this.createOpts.isBusinessClass) {
              navigate(getOrganizationBillingUrl(data.get('name')), {
                trigger: true,
              });
            } else if (this.createOpts.isEnterprise) {
              navigate(getOrganizationAccountUrl(data.get('name')), {
                trigger: true,
              });
            } else {
              Controller.organizationBoardsView(data.get('name'));
            }
            Analytics.sendTrackEvent({
              action: 'created',
              actionSubject: 'workspace',
              actionSubjectId: data.id,
              attributes: {
                isEnterprise: Boolean(this.createOpts.isEnterprise),
                isBusinessClass: Boolean(this.createOpts.isBusinessClass),
                category: this.createOpts.category,
                method: this.trackingOpts.method,
                ...this.createOpts.context,
              },
              containers: {
                board: {
                  id: this.model instanceof Board ? this.model.get('id') : null,
                },
                workspace: {
                  id: data.id,
                },
              },
              source: 'createWorkspaceModal',
            });
            PopOver.hide();
          })
          .done();
      },
    });
  }

  onChangeTeamType(teamTypeValue) {
    this.teamTypeValue = teamTypeValue;
    return this.updateSubmitButton();
  }

  renderTeamTypeSelect() {
    return this.whenIdle(`org_view_select_${this.cid}`, () => {
      const teamTypeSelectComponent = (
        <TeamTypeSelect onChange={this.onChangeTeamType} />
      );
      const teamTypeSelectDiv = this.el.querySelector('.js-team-type-select');
      return renderComponent(teamTypeSelectComponent, teamTypeSelectDiv);
    });
  }
}

CreateOrgView.initClass();
export { CreateOrgView };
